import type { ReactElement } from 'react';
import { Vendor, getCurrentVendor } from '@studio/design-system/themes/vendor.js';
import { TriggerIris } from './vendor/iris/trigger-iris.jsx';
import { TriggerHive } from './vendor/hive/trigger-hive.jsx';
import type { TriggerProps } from './types.js';

/** `<Trigger>` component that renders vendor-specific UI. */
export const Trigger = (props: TriggerProps): ReactElement => {
  const isIris = getCurrentVendor() === Vendor.IRIS;

  return isIris ? <TriggerIris {...props} /> : <TriggerHive {...props} />;
};
